import { applyEmptyChartState, seriesHasData } from '@/data/chartEmptyState.js'

export function getChartOptions(dataArray) {
    const ignoreList = ['/run', '/dev/shm', '/tmp', '/boot', '/sys', '/var/tmp'];

    var maxLabelLength = 6;
    var data = [];
    var categories = [];

    const colorOk = "#73bf69";
    const colorWarn = "#eab839";
    const colorDanger = "#f2495c";

    function isIgnored(item) {
        for (var j=0; j < ignoreList.length; j++) {
            if (item.startsWith(ignoreList[j])) {
                return true;
            }
        }
    }

    const keys = Object.keys(dataArray);
    for (var i=0; i<keys.length; i++) {
        const key = keys[i];
        if (key.length > maxLabelLength) maxLabelLength = key.length;
        const value = dataArray[keys[i]];
        if (isIgnored(key)) {
            continue;
        }

        var color = colorOk;
        if (value > 70) color = colorWarn;
        else if (value > 90) color = colorDanger;

        const itemCategory = { value: key, textStyle: { fontSize: 14, fontWeight: "bold" } };
        const itemData = { value: value, itemStyle: {color: color}};

        data.push(itemData);
        categories.push(itemCategory);
    }

    var leftSpace = ((maxLabelLength*5) + 10) + "px";

    const options = {
        tooltip: {
            trigger: 'item',
            formatter:
                    function(params) {
                        return params.data.value + ' %';
                    }
          },
        grid: {
            left: leftSpace,
            right: "10%",
            top: "10%",
            bottom: "10%"
        },
        xAxis: {
            max: 100,
            splitLine: { show: true },
            axisLabel: { show: true },
            axisTick: { show: true },
            axisLine: { show: true }
        },
        yAxis: {
            type: "category",
            data: categories,
            axisLabel: { show: true },
            axisTick: { show: true },
            axisLine: { show: true }
        },
        series: [
            {
                type: "bar",
                data: data,
                itemStyle: {
                    color: "#E0E0E0"
                },
                showBackground: true,
                label: {
                    show: true,
                    position: "insideLeft",
                    formatter: "{c}%",
                    color: "#000"
                }
            }
        ]
    }

    return applyEmptyChartState(options, seriesHasData(options.series))
}